import { LOAD, LOAD_SUCCESS, LOAD_FAIL } from 'redux/actions/locationAction';

const initialState = {
  loaded: false,
  loading: false,
  data: [],
};

function locationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case LOAD_SUCCESS:
      const locationList = state.data ? { ...state.data, ...action.payload.data } : action.payload.data;
      return {
        ...state,
        loading: false,
        loaded: true,
        data: locationList,
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export default locationReducer;
